import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type UpdateExpiryDateResponse = ApiError;

export const updateExpiryDate = (
  studentId: string,
  courseId: string,
  expiryDate: string
): Promise<UpdateExpiryDateResponse> => {
  return axios
    .patch(`/admin/updateExpiryDate/${studentId}/${courseId}`, { expiryDate })
    .then((response) => response.data as UpdateExpiryDateResponse);
};
